import "@mdi/font/css/materialdesignicons.css";
import "vuetify/styles";

import { Icon } from "@iconify/vue";
import { createVuetify, type IconSet, type IconProps } from "vuetify";

const iconify: IconSet = {
  // @ts-ignore
  component: (props: IconProps) => h(Icon, props),
};
export const icons = {
  defaultSet: "iconify",
  sets: {
    iconify,
  },
};

export default defineNuxtPlugin((app) => {
  const vuetify = createVuetify({
    locale: {
      locale: "en",
      fallback: "ar",
    },

    icons,
    theme: {
      defaultTheme: "light",
      themes: {
        light: {
          colors: {
            body: "#e5f1ff",
            divider: "#E1E1E1",
            surface: "#FFFFFF",
            "surface-dark": "#FFFFFF",
            text: "#000",

            // 👇 primary colors
            primary: "#089250",
            "primary-100": "#CEF1D5",
            "primary-200": "#9BDFAE",
            "primary-300": "#67C98C",
            "primary-400": "#34AF6D",
            "primary-500": "#089250",
            "primary-600": "#05814D",
            "primary-700": "#027049",
            "primary-800": "#005E42",
            "primary-900": "#004C39",

            // 👇 error colors
            error: "#F04438",
            "error-100": "#FEE4E2",
            "error-200": "#FECDCA",
            "error-300": "#FDA29B",
            "error-400": "#F97066",
            "error-500": "#F04438",
            "error-600": "#D92D20",
            "error-700": "#B42318",
            "error-800": "#B42318",
            "error-900": "#7A271A",

            // 👇 warning colors
            warning: "#F79009",
            "warning-100": "#FEF0C7",
            "warning-200": "#FEDF89",
            "warning-300": "#FEC84B",
            "warning-400": "#FDB022",
            "warning-500": "#F79009",
            "warning-600": "#DC6803",
            "warning-700": "#B54708",
            "warning-800": "#93370D",
            "warning-900": "#7A2E0E",

            // 👇 success colors
            success: "#17B26A",
            "success-100": "#DCFAE6",
            "success-200": "#ABEFC6",
            "success-300": "#75E0A7",
            "success-400": "#47CD89",
            "success-500": "#17B26A",
            "success-600": "#079455",
            "success-700": "#067647",
            "success-800": "#085D3A",
            "success-900": "#074D31",
          },
        },
        dark: {
          colors: {

            body: "#e5f1ff",
            divider: "#E1E1E1",
            surface: "#FFFFFF",
            "surface-dark": "#FFFFFF",
            text: "#000",

            // 👇 primary colors
            primary: "#089250",
            "primary-100": "#CEF1D5",
            "primary-200": "#9BDFAE",
            "primary-300": "#67C98C",
            "primary-400": "#34AF6D",
            "primary-500": "#089250",
            "primary-600": "#05814D",
            "primary-700": "#027049",
            "primary-800": "#005E42",
            "primary-900": "#004C39",

            // 👇 error colors
            error: "#F04438",
            "error-100": "#FEE4E2",
            "error-200": "#FECDCA",
            "error-300": "#FDA29B",
            "error-400": "#F97066",
            "error-500": "#F04438",
            "error-600": "#D92D20",
            "error-700": "#B42318",
            "error-800": "#B42318",
            "error-900": "#7A271A",

            // 👇 warning colors
            warning: "#F79009",
            "warning-100": "#FEF0C7",
            "warning-200": "#FEDF89",
            "warning-300": "#FEC84B",
            "warning-400": "#FDB022",
            "warning-500": "#F79009",
            "warning-600": "#DC6803",
            "warning-700": "#B54708",
            "warning-800": "#93370D",
            "warning-900": "#7A2E0E",

            // 👇 success colors
            success: "#17B26A",
            "success-100": "#DCFAE6",
            "success-200": "#ABEFC6",
            "success-300": "#75E0A7",
            "success-400": "#47CD89",
            "success-500": "#17B26A",
            "success-600": "#079455",
            "success-700": "#067647",
            "success-800": "#085D3A",
            "success-900": "#074D31",
          },
        },
      },
    },

    defaults: {
      VTextField: {
        variant: "outlined",
        color: "primary",
        rounded: "lg",
      },
      VTextarea: {
        variant: "outlined",
        color: "primary",
        rounded: "lg",
      },
      VAutocomplete: {
        variant: "outlined",
        color: "primary",
        rounded: "lg",
      },
      VFileInput: {
        variant: "outlined",
        color: "primary",
        rounded: "lg",
      },
      VDivider: {
        opacity: "100",
      },
      VSwitch: {
        color: "primary",
      },
      VSelect: {
        variant: "outlined",
        color: "primary",
        rounded: "lg",
      },
      VChip: {
        rounded: "lg",
      },
    },
    // ... your configuration
  });
  app.vueApp.use(vuetify);
});
